export const Client = {
    firstName: '',
    lastName: '',
    dob: '',
    annualBaseIncome: '',
    annualIncrease: '',
    bonus: '',
    taxBracket: '',
    retirementAge: '',
}

export const GroupCoverage = {
    percentCovered: '',
    waitingPeriod: '',
    includeBonus: '',
    monthlyMaximum: '',
    taxableBenefits: '',
    benefitPeriod: '',
    annualPremium: '',
}

export const GroupStdCoverage = {
    percentCovered: '',
    waitingPeriod: '',
    includeBonus: '',
    weeklyMaximum: '',
    taxableBenefits: '',
    benefitPeriod: '',
    annualPremium: '',
}

export const IndividualCoverage = {
    benefitAmount: '',
    monthlyMaximum: '',
    waitingPeriod: '',
    benefitPeriod: '',
    cola: '',
    futureIncrease: '',
    annualPremium: '',
    taxableBenefits: '',
}

export const coverage = {
    groupCoverages: [],
    groupStdCoverages: [],
    individualCoverages: [],
}

export const InsuredAsset = {
    name: '',
    estimatedValue: '',
    annualInsuranceCost: '',
}

export const Protection = {
    benefitAmount: '',
    monthlyMaximum: '',
    benefitPeriod: '',
    eliminationPeriod: '',
    cola: '',
    annualBenefitIncrease: '',
    annualBenefitIncreaseMaxAge: '',
    annualPremium: '',
    monthlyPremium: '',
    taxableBenefits: '',
    name: '',
    notes: '',
    blobId: '',
    catastrophicBenefitAmount: '',
}

export const InitialForm = {
    client: Client,
    coverage: Object.assign({}, coverage),
    assets: [],
    protections: {
        basic: Object.assign({}, Protection, { name: 'Basic' }),
        moderate: Object.assign({}, Protection, { name: 'Moderate' }),
        comprehensive: Object.assign({}, Protection, { name: 'Comprehensive' }),
    },
}

// export const InitialForm = {
//     client: {
//         firstName: 'first',
//         lastName: 'last',
//         dob: '07-12-1987',
//         state: 'MN',
//         gender: 'Male',
//         useTobacco: 'Yes',
//         notes: 'client notes'
//     },
//     occupation: {
//         company: 'company',
//         title: 'title',
//         duties: 'duties',
//         years: '22',
//         retirementAge: 65,
//         notes: 'occupation notes'
//     },
//     income: {
//         annualBaseIncome: '$100,000',
//         bonus: '$11,000',
//         businessOwner: 'Yes',
//         k1Distribution: '$11,500',
//         annualIncrease: '2%',
//         taxBracket: 25,
//         notes: 'income notes'
//     },
//     coverage: {
//         groupCoverages: [
//             {
//                 percentCovered: '32%',
//                 waitingPeriod: '30',
//                 includeBonus: 'Yes',
//                 monthlyMaximum: '$6,000',
//                 taxableBenefits: 'Yes',
//                 benefitPeriod: '70',
//                 annualPremium: '$5,000'
//             }
//         ],
//         individualCoverages: [
//             {
//                 benefitAmount: '$12',
//                 monthlyMaximum: '$45',
//                 waitingPeriod: '30',
//                 benefitPeriod: '65',
//                 cola: '2%',
//                 futureIncrease: '3%',
//                 annualPremium: '$3,222',
//                 taxableBenefits: 'Yes'
//             }
//         ]
//     },
//     assets: {
//         primaryHouse: {
//             estimatedValue: '$1',
//             annualInsuranceCost: '$2'
//         },
//         secondaryHouse: {
//             estimatedValue: '$3',
//             annualInsuranceCost: '$4'
//         },
//         firstCar: {
//             estimatedValue: '$5',
//             annualInsuranceCost: '$6'
//         },
//         secondCar: {
//             estimatedValue: '$7',
//             annualInsuranceCost: '$8'
//         },
//         thirdCar: {
//             estimatedValue: '$9',
//             annualInsuranceCost: '$10'
//         },
//         motorcycle: {
//             estimatedValue: '$11',
//             annualInsuranceCost: '$12'
//         },
//         boat: {
//             estimatedValue: '$13',
//             annualInsuranceCost: '$14'
//         },
//         miscellaneous: {
//             estimatedValue: '$15',
//             annualInsuranceCost: '$16'
//         }
//     },
//     protections: {
//         basic: {
//             benefitAmount: '$1',
//             monthlyMaximum: '$1',
//             benefitPeriod: '65',
//             eliminationPeriod: '180',
//             cola: '1%',
//             annualBenefitIncrease: '1%',
//             annualPremium: '$1',
//             monthlyPremium: '$1',
//             taxableBenefits: 'Yes'
//         },
//         moderate: {
//             benefitAmount: '$2',
//             monthlyMaximum: '$2',
//             benefitPeriod: '67',
//             eliminationPeriod: '60',
//             cola: '2%',
//             annualBenefitIncrease: '2%',
//             annualPremium: '$2',
//             monthlyPremium: '$2',
//             taxableBenefits: 'Yes'
//         },
//         comprehensive: {
//             benefitAmount: '$3',
//             monthlyMaximum: '$3',
//             benefitPeriod: '65',
//             eliminationPeriod: '30',
//             cola: '3%',
//             annualBenefitIncrease: '3%',
//             annualPremium: '$3',
//             monthlyPremium: '$3',
//             taxableBenefits: 'Yes'
//         }
//     }
// }
